import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '@/app/components/translations/Translation.tsx';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { BaseBadgeContainer } from '../BaseBadge/styled';

const MyPriceLabelBadge = styled(BaseBadgeContainer)`
  background-color: ${({ theme }) => theme.kallisto.color.common.special.myPrice[500]};
  color: ${({ theme }) => theme.kallisto.color.background.static.backgroundPage};
`;

/** The MyPrice label. The discount percentage is MyPriceDiscountBadge, in the price addons slot. */
const MyPriceBadge = () => {
  const { t } = useTranslation();
  const { localization } = usePageWrapperData();
  const imageBasePath = localization?.imageBasePath;

  return (
    <MyPriceLabelBadge
      $icon={`${imageBasePath}icons/my_price_white.svg`}
      dangerouslySetInnerHTML={{ __html: t('vacation.oss.cards.myprice_label_html') }}
    />
  );
};

export default MyPriceBadge;
